import React from 'react';

import { getIn } from 'formik';
import { FormikValues } from 'formik/dist/types';

import AppDateTimePicker from '../../textfields/app-date-time-picker';

interface IFormDateTimePicker {
  formik: FormikValues | undefined;
  name: string;
  label?: string;
  minDateTime?: Date | null;
  maxDateTime?: Date | null;
  mode?: 'light' | 'dark';
}

const AppFormDateTimePicker: React.FC<IFormDateTimePicker> = ({
  formik,
  name,
  mode,
  ...props
}) => {
  return (
    <AppDateTimePicker
      {...props}
      error={formik?.touched[name] && !!formik?.errors[name]}
      helperText={formik?.touched[name] && formik?.errors[name]}
      onChange={(value) => {
        formik && formik.setFieldValue(name, value);
      }}
      value={getIn(formik?.values, name) || null}
      mode={mode}
    />
  );
};

export default AppFormDateTimePicker;
